import * as React from 'react';
import { Link } from 'react-router-dom';
import Page from '../components/Page';
import CategoryList from '../components/CategoryList';
import Loader from '../components/Loader';
import { ErrorFlash } from '../components/Flash';
import { classes } from '../components/Button';
import { ProfileContext, ProfileManager } from '../profile';
import { useRequest, getHeaders } from '../api/client';
import { Category } from '../product';

const newCategory: Category = {
  id: null,
  name: '',
  parent_id: null,
  image_url: null,
  description_text: null,
};

const categories = (context: ProfileManager) => {
  const [state, _] = useRequest(() => ({
    url: '/store/categories',
    method: 'GET',
    headers: getHeaders(context),
  }));

  return state;
};

export default function Categories() {
  const context = React.useContext(ProfileContext);
  const state = categories(context);

  if (state.loading) {
    return <Loader />;
  }

  return (
    <Page title="Categories" subtitle="Manage the categories">
      {state.error && <ErrorFlash error={state.error} />}
      <div className="flex justify-center ml-auto mr-auto">
        <Link
          to={{
            pathname: '/categories/edit/new',
            state: {
              category: { ...newCategory },
            },
          }}
          className={`${classes} dib ml-auto mr-auto`}
        >
          Create new
        </Link>
      </div>
      <CategoryList categories={state.data || []} />
    </Page>
  );
}
